// helpstep Energy

const steps = [
  { //STEP 1
    disableBeacon: true,
    target: '.chart-area',
    title: 'Grafico',
    content: 'Qui trovi il grafico generato su base dell\'ultimo mese',
    placement: "bottom",
  },
  { //STEP 2
    target: '.graphic-choice',
    title: 'Scelta grafico',
    content: 'Puoi scegliere come visualizzare i dati',
    placement: "bottom",
  },
  { //STEP 3
    target: '.variables-table',
    title: 'Variabili',
    content: 'Puoi premere questo pulsante per scegliere le variabili da visualizzare nel grafico',
    placement: "top",
  },
  { //STEP 4
    target: '.variables-select',
    title: 'Selezione variabili',
    content: 'Puoi scegliere quali variabili visualizzare nel grafico',
    placement: "left",
    clickOnPreviousElementBeforeEntering: true,
  },
  { //STEP 5
    target: '.variables-color',
    title: 'Colore variabili',
    content: 'Puoi scegliere il colore delle variabili',
    placement: "left",
  },
  { //STEP 6
    target: '.variables-search',
    title: 'Ricerca variabili',
    content: 'Puoi effettuare una ricerca delle variabili',
    placement: "top",
  },
  { //STEP 7
    target: '.variables-confirm',
    title: 'Conferma',
    content: 'Conferma le modifiche effettuate',
    placement: "top",
  },
  { //STEP 8
    target: '.period-selector',
    title: 'Periodo',
    content: 'Scegli per quale periodo generare il grafico',
    clickOnElementBeforeEntering: '#closeVariablesModalButton',
  },
  { //STEP 9
    target: '.period_last_month',
    title: 'Ultimo mese',
    content: 'Filtra per ultimo mese',
    clickOnPreviousElementBeforeEntering: true,  
  },
  { //STEP 10
    target: '.period_month',
    title: 'Mensile',
    content: 'Filtra per un mese e un anno specifico',
    clickOnElementOnEntering: true,
  },
  { //STEP 11
    target: '#monthPicker',
    title: 'Mese',
    content: 'Cambia mese',
  },
  { //STEP 12
    target: '#yearPicker',
    title: 'Anno',
    content: 'Cambia anno',
  },
  { //STEP 13
    target: '.period_annual',
    title: 'Annuale',
    content: 'Filtra per anno',
    clickOnElementOnEntering: true,
  },
  { //STEP 14
    target: '#yearPicker2',
    title: 'Anno',
    content: 'Cambia anno', 
  },
  { //STEP 15
    target: '.previousPeriod',
    title: 'Paragone periodo',
    content: 'Puoi visualizzare, nel grafico, dati precedenti al periodo selezionato', 
    clickOnElementBeforeEntering: '#closeVariablesModalButton',
  },
  { //STEP 16
    target: '.download-report-button',
    title: 'Download report',
    content: 'Scarica un report in formato pdf basato sui filtri attuali',
  },
];

export default steps;
